import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-cream border-t border-ink/10 text-ink">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="font-serif text-2xl tracking-wider">
              VALENTIS
              <span className="block text-xs tracking-[0.3em] mt-1 opacity-80">LAW GROUP</span>
            </div>
            <p className="text-sm text-ink/60 leading-relaxed">
              Cross border law firm focused on international dispute resolution and enforcement work involving India, China, and other Asian and Middle Eastern markets.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold tracking-wider mb-6 uppercase">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-ink/60 hover:text-ink transition-colors duration-300">About Us</Link></li>
              <li><Link to="/practice-areas" className="text-sm text-ink/60 hover:text-ink transition-colors duration-300">Practice Areas</Link></li>
              {/* <li><Link to="/team" className="text-sm text-ink/60 hover:text-ink transition-colors duration-300">Our Team</Link></li> */}
              <li><Link to="/careers" className="text-sm text-ink/60 hover:text-ink transition-colors duration-300">Careers</Link></li>
            </ul>
          </div>

          {/* Practice Areas */}
          {/* <div>
            <h3 className="text-sm font-semibold tracking-wider mb-6 uppercase">Practice Areas</h3>
            <ul className="space-y-3">
              <li className="text-sm text-ink/60">Corporate Law</li>
              <li className="text-sm text-ink/60">Litigation</li>
              <li className="text-sm text-ink/60">Mergers & Acquisitions</li>
              <li className="text-sm text-ink/60">Intellectual Property</li>
            </ul>
          </div> */}

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-semibold tracking-wider mb-6 uppercase">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="mt-1 text-ink/60" />
                <span className="text-sm text-ink/60">STS 001, DLF Star Tower<br />Sector 30, Gurugram 122001, India</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={16} className="text-ink/60" />
                <a href="tel:+919654234196" className="text-sm text-ink/60 hover:text-ink transition-colors duration-300">+91 96542 34196</a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={16} className="text-ink/60" />
                <a href="mailto:contact@valentislaw.com" className="text-sm text-ink/60 hover:text-ink transition-colors duration-300">contact@valentislaw.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-ink/10 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-xs text-ink/40 tracking-wider">
            © {new Date().getFullYear()} VALENTIS LAW GROUP. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="#" className="text-xs text-ink/40 hover:text-ink transition-colors duration-300 tracking-wider">Privacy Policy</Link>
            <Link to="#" className="text-xs text-ink/40 hover:text-ink transition-colors duration-300 tracking-wider">Terms of Service</Link>
            <Link to="#" className="text-xs text-ink/40 hover:text-ink transition-colors duration-300 tracking-wider">Legal Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;